import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

import Computers from "./pages/Computers";

import ProtectedRoute from "./components/ProtectedRoute";
import WebsiteApp from "./website/App";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Dealers from "./pages/Dealers";
import AdminHierarchy from "./pages/AdminHierarchy";
import Shops from "./pages/Shops";
import Players from "./pages/Players";
import TransferDealer from "./pages/TransferDealer";
import TransferShop from "./pages/TransferShop";
import TransferPlayer from "./pages/TransferPlayer";
import PendingWinners from "./pages/PendingWinners";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Game from "./pages/Game";
import BetHistory from "./pages/BetHistory";
import WalletHistory from "./pages/WalletHistory";


import ComputerDashboard from "./pages/ComputerDashboard";
import ComputerHistory from "./pages/ComputerHistory";
import FunRouletteGame from "./pages/FunRouletteGame";

function App() {
  return (
    <BrowserRouter>
      {/* Toast Notification Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Routes>
        {/* Website Landing Page */}
        <Route path="/" element={<WebsiteApp />} />

        {/* Public Login */}
        <Route path="/login" element={<Login />} />

        {/* Dashboard (All Authorized Roles) */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={["SUPER_ADMIN", "DEALER", "SHOP", "PLAYER"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Dealers Module (SUPER_ADMIN only) */}
        <Route
          path="/dealers"
          element={
            <ProtectedRoute allowedRoles={["SUPER_ADMIN"]}>
              <Dealers />
            </ProtectedRoute>
          }
        />

        {/* Admin Hierarchy Module (SUPER_ADMIN only) */}
        <Route
          path="/hierarchy"
          element={
            <ProtectedRoute allowedRoles={["SUPER_ADMIN"]}>
              <AdminHierarchy />
            </ProtectedRoute>
          }
        />

        {/* Transfer to Dealer Module (SUPER_ADMIN only) */}
        <Route
          path="/transfer-dealer"
          element={
            <ProtectedRoute allowedRoles={["SUPER_ADMIN"]}>
              <TransferDealer />
            </ProtectedRoute>
          }
        />

        {/* Shops Module (DEALER & SUPER_ADMIN) */}
        <Route
          path="/shops"
          element={
            <ProtectedRoute allowedRoles={["DEALER", "SUPER_ADMIN"]}>
              <Shops />
            </ProtectedRoute>
          }
        />

        {/* Transfer to Shop Module (DEALER & SUPER_ADMIN) */}
        <Route
          path="/transfer-shop"
          element={
            <ProtectedRoute allowedRoles={["DEALER", "SUPER_ADMIN"]}>
              <TransferShop />
            </ProtectedRoute>
          }
        />
        {/* Computers Module (SHOP only) */}
<Route
  path="/computers"
  element={
    <ProtectedRoute allowedRoles={["SHOP"]}>
      <Computers />
    </ProtectedRoute>
  }
/>


<Route
  path="/computer-dashboard"
  element={
    <ProtectedRoute allowedRoles={["COMPUTER"]}>
      <ComputerDashboard />
    </ProtectedRoute>
  }
/>

        {/* Players Module (SHOP only) */}
        <Route
          path="/players"
          element={
            <ProtectedRoute allowedRoles={["SHOP"]}>
              <Players />
            </ProtectedRoute>
          }
        />



        {/* Transfer to Player Module (SHOP only) */}
        <Route
          path="/transfer-player"
          element={
            <ProtectedRoute allowedRoles={["SHOP"]}>
              <TransferPlayer />
            </ProtectedRoute>
          }
        />

        {/* Legacy Transfer route redirect */}
        <Route path="/transfer" element={<Navigate to="/transfer-player" replace />} />

        {/* Pending Winners Module (SHOP only) */}
        <Route
          path="/pending-winners"
          element={
            <ProtectedRoute allowedRoles={["SHOP"]}>
              <PendingWinners />
            </ProtectedRoute>
          }
        />

        {/* Reports Module (All Authorized Roles) */}
        <Route
          path="/reports"
          element={
            <ProtectedRoute allowedRoles={["SUPER_ADMIN", "DEALER", "SHOP", "PLAYER"]}>
              <Reports />
            </ProtectedRoute>
          }
        />

        {/* Settings Module (All Authorized Roles) */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute allowedRoles={["SUPER_ADMIN", "DEALER", "SHOP", "PLAYER"]}>
              <Settings />
            </ProtectedRoute>
          }
        />

        {/* Player Game Module (PLAYER only) */}
        <Route
  path="/game"
  element={
    <ProtectedRoute allowedRoles={["PLAYER", "COMPUTER"]}>
      <Game />
    </ProtectedRoute>
  }
/>

<Route
  path="/fun-roulette"
  element={
    <ProtectedRoute allowedRoles={["PLAYER", "COMPUTER"]}>
      <FunRouletteGame />
    </ProtectedRoute>
  }
/>

<Route
  path="/computer-history"
  element={
    <ProtectedRoute allowedRoles={["COMPUTER"]}>
      <ComputerHistory />
    </ProtectedRoute>
  }
/>

        {/* Player Bet History Module (PLAYER only) */}
        <Route
          path="/bet-history"
          element={
            <ProtectedRoute allowedRoles={["PLAYER"]}>
              <BetHistory />
            </ProtectedRoute>
          }
        />

        {/* Player Wallet History Module (PLAYER only) */}
        <Route
          path="/wallet-history"
          element={
            <ProtectedRoute allowedRoles={["PLAYER"]}>
              <WalletHistory />
            </ProtectedRoute>
          }
        />

        {/* Fallback Catch-all Route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;